import React, { useState, useEffect, useRef, useMemo } from 'react';
import axios from 'axios';
import { Base_Url } from '../config';
import { useParams, useNavigate } from 'react-router-dom';
import JoditEditor from 'jodit-react';



const  AddAdvancedServiceCard = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const editor = useRef(null);

    const [serviceData, setServiceData] = useState({
        title: '',
        items: [{ name: '', link: '', }],
        externalLink: '',
        intlink: '',
        parentpath: '',
        // title: '',
        // pagedetails: '',
        icon: '',
        author: '',
        isHighlight: false,
        description: ''
    });


    const editorConfig = useMemo(() => ({
        readonly: false,
        minHeight: 400,
        editHTMLDocumentMode: true,
        buttons: [
            'source',
            '|',
            'bold',
            'italic',
            'underline',
            'strikethrough',
            'eraser',
            '|',
            'ul',
            'ol',
            'indent',
            'outdent',
            '|',
            'font',
            'fontsize',
            'paragraph',
            'lineHeight',
            'brush',
            '|',
            'superscript',
            'subscript',
            'classSpan',
            '|',
            'file',
            'image',
            'video',
            '|',
            'spellcheck',
            'speechRecognize',
            '|',
            'cut',
            'copy',
            'paste',
            'selectall',
            'copyformat',
            '|',
            'hr',
            'table',
            'link',
            'symbols',
            '|',
            'ai-commands',
            'ai-assistant',
            '|',
            'left',
            '|',
            'undo',
            'redo',
            '|',
            'find',
            'fullsize',
            'preview',
            'print',
            'about'
        ],
        plugins: [
            'add-new-line',
            'ai-assistant',
            'backspace',
            'bold',
            'class-span',
            'clean-html',
            'clipboard',
            'color',
            'copyformat',
            'delete-command',
            'drag-and-drop',
            'drag-and-drop-element',
            'dtd',
            'enter',
            'file',
            'focus',
            'font',
            'format-block',
            'fullsize',
            'hotkeys',
            'hr',
            'iframe',
            'image',
            'image-processor',
            'image-properties',
            'indent',
            'inline-popup',
            'justify',
            'key-arrow-outside',
            'limit',
            'line-height',
            'link',
            'media',
            'mobile',
            'ordered-list',
            'paste',
            'paste-from-word',
            'paste-storage',
            'placeholder',
            'powered-by-jodit',
            'preview',
            'print',
            'redo-undo',
            'resize-cells',
            'resize-handler',
            'resizer',
            'search',
            'select',
            'select-cells',
            'size',
            'source',
            'speech-recognize',
            'spellcheck',
            'stat',
            'sticky',
            'symbols',
            'tab',
            'table',
            'table-keyboard-navigation',
            'video',
            'wrap-nodes',
            'xpath'
        ],
        lists: {
            indent: true,
            startIndent: 20,
        },
    }), []);

    // console.log(serviceData.icon)
    const [error, setError] = useState('');
    const [content, setContent] = useState('');
    const [success, setSuccess] = useState('');
    // const [loading, setLoading] = useState(false);


    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setServiceData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setSuccess('');
        const validationErrors = [];

        if (!serviceData.title || serviceData.title.trim() === '') {
            validationErrors.push('Title is required');
        }

        if (validationErrors.length > 0) {
            setError(validationErrors.join('. '));
            return;
        }

        try {
            // Prepare data for submission
            const submissionData = {
                title: serviceData.title || null,
                link: serviceData.link || null,
                intlink: serviceData.intlink || null,
                pagedetails: content || null,
                icon: serviceData.icon || null,
            };

            // Submission with axios
            const response = await axios.post(`${Base_Url}/howto`, submissionData, {
                headers: {
                    'Content-Type': 'application/json'
                }
            });

            // Check response status
            if (response.status === 200 || response.status === 201) {
                setSuccess('HowtoDetails added successfully!');

                setServiceData({
                    title: "",
                    link: "",
                    pagedetails: "",
                    icon: "",
                });

                window.location.reload();
            } else {
                // Unexpected response
                setError('Unexpected response from server');
            }

        } catch (err) {

            console.error('Submission Error:', err);

            let errorMessage = 'Failed to add service';

            if (err.response) {
                console.error('Error Response Data:', err.response.data);
                console.error('Error Response Status:', err.response.status);

                errorMessage = err.response.data.message ||
                    err.response.data.error ||
                    `Server error: ${err.response.status}`;
            } else if (err.request) {
                console.error('No response received:', err.request);
                errorMessage = 'No response from server. Please check your network connection.';
            } else {
                console.error('Error setting up request:', err.message);
                errorMessage = `Request setup error: ${err.message}`;
            }

            setError(errorMessage);
        }
    };

    return (
        <div className="container mt-5">
            <div className="row justify-content-center">
                <div className="col-md-8">
                    <div className="card">
                        <div className="card-header">
                            <h2 className="text-center">Add HowTo Content</h2>
                        </div>
                        <div className="card-body">
                            {error && (
                                <div className="alert alert-danger" role="alert">
                                    {error}
                                </div>
                            )}
                            {success && (
                                <div className="alert alert-success" role="alert">
                                    {success}
                                </div>
                            )}
                            <form onSubmit={handleSubmit}>
                                <div className="mb-3">
                                    <label className="form-label">Card Title</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="title"
                                        placeholder='Your Card Name'
                                        value={serviceData.title}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>


                                <div className="mb-3">
                                    <label className="form-label">External Link </label>
                                    <input
                                        type="url"
                                        className="form-control"
                                        name="link"
                                        value={serviceData.link}
                                        onChange={handleChange}
                                        placeholder="https://example.com"
                                    />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">Route Link </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="intlink"
                                        value={serviceData.intlink}
                                        onChange={handleChange}
                                        placeholder="Your Route link"
                                    />
                                </div>
                               

                                <div className="text-center">
                                    <button
                                        type="submit"
                                        className="btn btn-primary btn-lg"
                                    // disabled={loading}
                                    >
                                        Add
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AddAdvancedServiceCard;